import React from 'react';
import { TextField, InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

interface SearchBarProps {
  searchQuery: string;
  onSearchChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
}

const SearchBar: React.FC<SearchBarProps> = ({
  searchQuery,
  onSearchChange,
  placeholder = 'Search...',
}) => {
  return (
    <TextField
      size="small"
      placeholder={placeholder}
      value={searchQuery}
      onChange={onSearchChange}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon fontSize="small" />
          </InputAdornment>
        ),
      }}
      sx={{
        minWidth: 250,
        '& .MuiOutlinedInput-root': {
          '&:hover fieldset': {
            borderColor: (theme: any) => theme.palette.themeColor?.main,
          },
          '&.Mui-focused fieldset': {
            borderColor: (theme: any) => theme.palette.themeColor?.main,
          },
        },
      }}
    />
  );
};

export default SearchBar;
